@import "../../css/spinner.css";

:host {
  all: initial;
  color: var(--zapier-text);
  font-family: var(--zapier-font-family);
  display: block;
  position: relative;
  z-index: 901;
}

button {
  all: initial;
  font: inherit;
  outline: none;
  background: none;
  border: none;
  cursor: pointer;
}

button:focus-visible {
  outline: 1px solid var(--zapier-brand);
}

/* We found that Safari wasn't taking into consideration the container queries
   when using the Host element as the container, so we had to re-write it and
   make changes to the elements adding a wrapper element below the Host. This we
   mainly needed due to Safari issue. On other browsers, we were able to use the
   Host element as the container.

   https://codepen.io/wavebeem/pen/RwdVvJO
*/
.app-select-host-container {
  container: app-select-host-container;
  container-type: inline-size;
}

.app-select-container {
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 1fr;
  grid-template-areas:
    "app-label"
    "app-input"
    "plus"
    "search-label"
    "search-input";
}

.app-select-container > * {
  min-width: 0;
}

svg {
  fill: var(--zapier-text-80);
}

.plus-app {
  display: flex;
  align-items: center;
  justify-content: center;
  grid-area: plus;
  margin-bottom: -24px;
}

.plus-app > svg {
  --icon-color: rgb(0 0 0 / 0.3);
  transform: rotate(90deg);
}

:host([data-theme="dark"]) .plus-app > svg {
  --icon-color: rgb(255 255 255 / 0.4);
}

/* stylelint-disable no-descending-specificity */
.close svg:focus,
.close svg:hover {
  fill: var(--zapier-brand);
}
/* stylelint-enable no-descending-specificity */

.connect-this {
  grid-area: app-label;
}

.with-this {
  grid-area: search-label;
}

.app-select-container h3 {
  margin: 0;
  font-size: var(--zapier-font-size-16px);
}

.main-app {
  grid-area: app-input;
}

.search {
  grid-area: input;
}

:host,
input {
  font-family: var(--zapier-font-family);
  font-size: var(--zapier-font-size-16px);
  line-height: 1.5;
}

.inner {
  grid-area: search-input;
  display: grid;
  grid-template-areas: "left input right";
  grid-template-columns: 44px 1fr max-content;
  grid-template-rows: 1fr;
  position: relative;
  border-radius: var(--zapier-grid-unit);
  background-color: var(--zapier-bg-5);
  align-items: center;
}

.inner > * {
  min-width: 0;
}

.icon-container {
  gap: var(--zapier-grid-unit);
  align-items: center;
  box-sizing: border-box;
  display: flex;
  height: 44px;
  color: var(--zapier-text-80);
  justify-content: center;
  position: relative;
  z-index: 1;
  border-radius: var(--zapier-grid-unit);
}

.icon-container.right {
  padding-right: var(--zapier-grid-unit);
}

.icon-container.left {
  padding-left: var(--zapier-grid-unit);
}

.icon-container .spinner {
  transition: 250ms opacity;
}

@media (prefers-reduced-motion) {
  .icon-container .spinner {
    transition: none;
  }
}

.icon-container .spinner[hidden] {
  display: initial;
  opacity: 0;
}

.icon-container button {
  all: initial;
  color: var(--zapier-text);
  font: inherit;
  margin-right: -4px;
}

.icon-container button[hidden] {
  display: none;
}

.main-app.icon-container {
  width: 100%;
  justify-content: flex-start;
  place-self: center;
  padding: var(--zapier-grid-unit);
  padding-right: 20px;
  background: var(--zapier-bg-5);
  color: var(--zapier-text-80);
  pointer-events: none;
}

.app-name {
  margin-left: var(--zapier-grid-unit);
  color: var(--zapier-text);
}

.icon {
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon.bg {
  width: 30px;
  height: 30px;
  padding: calc(var(--zapier-grid-unit) / 2);
  background: var(--zapier-icon-bg);
  background-clip: padding-box;
  border: 1px solid var(--zapier-service-icon-border-color);
  border-radius: var(--zapier-button-input-border-radius);
}

.icon img {
  width: 20px;
  height: 20px;
  display: block;
  object-fit: contain;
}

.main-app.icon-container img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.results .text {
  margin-left: var(--zapier-grid-unit);
}

input {
  box-sizing: border-box;
  height: 44px;
  display: block;
  margin: 0;
  padding: 10px 0;
  color: var(--zapier-bg-120);
  border: none;
  grid-area: 1 / 1 / 4 / 4;
  outline: none;
  background: none;
}

input::placeholder {
  opacity: 1;
  color: var(--zapier-text-60);
}

.inner.search:hover {
  outline: 2px solid var(--zapier-brand);
  outline-offset: -1px;
}

.inner.search:focus,
.inner.search:focus-within {
  position: relative;
  outline: 3px solid var(--zapier-brand);
  outline-offset: -2px;
}

.main-app,
.inner {
  border: 1px solid var(--zapier-input-border-color);
  border-radius: var(--zapier-button-input-border-radius);
}

.combobox-wrapper {
  position: relative;
  grid-area: search-input;
}

.results {
  grid-area: results;
  position: absolute;
  right: 0;
  left: 0;
  z-index: 900;
  margin: 10px 0 0;
  background: var(--zapier-modal-background-color);
  border-radius: 3px;
  box-shadow: rgb(0 0 0 / 20%) 0 10px 30px 0;
}

.no-results {
  padding: 0 20px;
  color: var(--zapier-text-80);
}

ul {
  padding: var(--zapier-grid-unit);
  list-style-type: none;
}

.results ul:focus-visible {
  outline: 1px solid var(--zapier-brand);
}

li {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 var(--zapier-grid-unit);
  font-size: var(--zapier-font-size-14px);
  font-weight: 400;
  border-radius: 3px;
  cursor: pointer;
}

.results-app.enabled {
  font-weight: 600;
  color: var(--zapier-brand);
  background-color: var(--zapier-bg-5);
}

.results .results-app.highlight {
  font-weight: bold;
  background: var(--zapier-button-bg);
  color: var(--zapier-button-text);
}

[hidden] {
  display: none;
}

:host([data-theme="dark"]) .results {
  box-shadow: rgb(0 0 0 / 80%) 0 10px 30px 0;
}

:host([data-theme="dark"]) .main-app,
:host([data-theme="dark"]) .inner {
  background: rgb(255 255 255 / 10%);
}

/* Container queries */
@container app-select-host-container (min-width: 768px) {
  .app-select-container {
    row-gap: var(--zapier-grid-unit);
    grid-template-columns: 1fr max-content 2fr;
    grid-template-areas:
      "app-label  ....  search-label"
      "app-input  plus  search-input";
  }

  .plus-app {
    margin: 0;
  }
  .plus-app > svg {
    transform: rotate(0deg);
  }
}
